import { useTranslation } from 'react-i18next';

import { Box } from '@material-ui/core';

import type { ShowDialogType } from '@admin/shared/context/dialog';
import { TrashFilledIcon } from '@admin/shared/components/icons/custom/trash';
import { DialogSizes, useDialogStyles } from '@admin/shared/components/dialogs/dialog';

export type ShowDeleteDialogType = (onConfirm: () => Promise<void> | void) => void;

/**
 * Opens dialog to confirm delete of entry.
 *
 * @param showDialog - show dialog hook.
 */
export const useDeleteDialog = (showDialog: ShowDialogType): ShowDeleteDialogType => {
  const { t } = useTranslation();
  const styles = useDialogStyles();

  // return function that can be called by
  // dialog context to show the dialog
  return (onConfirm) => {
    showDialog({
      size: DialogSizes.SMALL,
      children: (
        <Box display="flex" flexDirection="column" alignItems="center">
          <TrashFilledIcon className={styles.icon} />
          <p className={styles.headline}>{t('common:dialogs.delete.title')}</p>
          <p className={styles.text}>{t('common:dialogs.delete.text')}</p>
        </Box>
      ),
      actions: [
        {
          label: t('common:actions.delete'),
          color: 'primary',
          action: onConfirm,
        },
        {
          label: t('common:actions.cancel'),
          autoFocus: true,
        },
      ],
    });
  };
};
